import { Component, inject, Inject, PLATFORM_ID } from '@angular/core';
import { BasePageComponent } from '../../../base-page/base-page.component';
import { ToggleMenuBackService } from 'src/app/services/utils/toggle-menu-back.service';
import { BestGamesService } from 'src/app/services/client-area/best-games.service';
import { filter, finalize, switchMap, take, takeUntil } from 'rxjs/operators';
import { GameItem } from 'src/app/apollo/models/base-models';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { AvatarService } from '../../../../services/profile/avatar.service';
import { LoginStatusService } from '../../../../services/auth/login/login-status.service';
import { Subscription } from 'rxjs';
import { GamificationLevelService } from '../../../../services/profile/gamification-level.service';
import { UserBonusLottery, UserChargeback } from '../../../../services/profile/profile.models';
import { ChargebackService } from '../../../../services/profile/chargeback.service';
import { PrizeBoxService } from '../../../../services/client-area/prize-box.service';
import {
  bonusQueueTrx,
  bonusTrx,
  cashbackTrx,
  changePasswordTrx,
  clientAreaTrx,
  editProfileTrx,
  infoTrx,
  lemonLotteryTermsTrx, myGamesTrx,
  prizeBoxTrx,
  redeemPromocodeTrx,
  treasureBoxesTrx,
  uploadDocumentsTrx
} from '../../../../router-translation.labels';
import { TranslationConfig } from '../../../../utils/translate-config';
import { BonusLotteryService } from '../../../../services/profile/bonuslottery.service';
import { Router } from '@angular/router';
import { SwiperOptions } from 'swiper';
import { isPlatformBrowser } from '@angular/common';
import { BonusQueueService } from 'src/app/services/wallet/bonus-queue.service';
import { BonusQueueItem } from 'src/app/services/wallet/wallet.models';
import { UserFullInfoService } from 'src/app/services/auth/check-session/user-full-info.service';
import { UserFullInfo } from 'src/app/services/auth/login/login.models';
import { MatDialog } from '@angular/material/dialog';
import { DialogConfig, TEST_SUCCESS_DIALOG_CONFIG } from 'src/app/components/dialog/dialog.config';
import { ErrorDialogComponent } from 'src/app/components/dialog/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/components/dialog/success-dialog/success-dialog.component';

const LEVEL_NAMES = ['green', "yellow", "bronze", "silver", "gold", "diamond"];
const LEVEL_POSITIONS = ['Lvl 1-5', 'Lvl 6-10', 'Lvl 11-15', 'Lvl 16-20', 'Lvl 21-25', 'Lvl 26-30'];

@Component({
  template: '',
})
export class BaseMainClientAreaComponent extends BasePageComponent {

  constructor(
    protected chargebackService: ChargebackService,
    private translationConfig: TranslationConfig,
    private toggleBackService: ToggleMenuBackService,
    private loaderService: LoaderService,
    private bestGamesService: BestGamesService,
    private deviceDetectService: DetectDeviceService,
    private loginStatusService: LoginStatusService,
    private avatarService: AvatarService,
    private gamificationLevelService: GamificationLevelService,
    private prizeBoxService: PrizeBoxService,
    private bonusLotteryService: BonusLotteryService,
    private router: Router,
    private bonusQueueService: BonusQueueService,
    private userFullInfoService: UserFullInfoService,
    public errorDialog: MatDialog,
  ) {
    super();
    this.platformId = inject<string>(PLATFORM_ID);
  }

  platformId: string;

  config: SwiperOptions = {
    direction: 'horizontal',
    slidesPerView: 1.16,
    spaceBetween: 16,
    pagination: false,
    navigation: false,
  };

  isVisible = true;
  bestGames: GameItem[];
  bestGameCategoryName: string = $localize`:@@bestGameCategoryName:Most played`;
  bestGamesShowMore = false;
  profileName = $localize`:@@profile-title:Profile`;
  avatar: string;
  email: string;
  verified: string;
  gamificationSubscription: Subscription;
  gamificationPercentFill: number = 0.;
  gamificationLevel: number = 1;
  playerLoyalityName: string;
  playerNextLoyalityName: string;
  playerLevelPosition: string;
  playerNextLevelPosition: string;
  playerLoyalityNameIndex: number = 0;
  showGamification: boolean;
  chargebackFormatted: string;
  dailyChargebackFormatted: string
  nextChargebackDate: Date;
  chargebackPercentFill: number = 0.;
  chargebackSubscription: Subscription;
  userChargeback: UserChargeback;
  userChargebackToClaim: UserChargeback;
  userBonusLotteryResponse: UserBonusLottery;
  isPrizeBoxActive = false;
  lemonIconNameIndex: number;
  lemonNextLevelIconNameIndex: number;
  userRole: boolean;
  playerCurrentLevelList: any[] = [];
  gamificationTotalLevelPercent: number = 0.;
  bonusQueue: BonusQueueItem[];
  userInfo: UserFullInfo;
  kyc_status: string = "";
  kycRequested: boolean = false;
  protected dialogOpened:boolean = false;
  readonly uploadDocumentsTrx: string = '/' + this.translationConfig.getTranslation(uploadDocumentsTrx);


  readonly lotteryInfoUrl: string = '/' + this.translationConfig.getTranslation(bonusTrx) + '/' + this.translationConfig.getTranslation(lemonLotteryTermsTrx);
  readonly treasureBoxInfoUrl: string = '/' + this.translationConfig.getTranslation(infoTrx) + '/' + this.translationConfig.getTranslation(treasureBoxesTrx);
  readonly cashbackInfoUrl: string = '/' + this.translationConfig.getTranslation(infoTrx) + '/' + this.translationConfig.getTranslation(cashbackTrx);
  readonly editProfileUrl: string = '/' + this.translationConfig.getTranslation(editProfileTrx);
  readonly changePasswordUrl: string = '/' + this.translationConfig.getTranslation(changePasswordTrx);
  readonly bonusesUrl: string = '/' + this.translationConfig.getTranslation(clientAreaTrx) + '/' + this.translationConfig.getTranslation(bonusQueueTrx);
  readonly myGamesUrl: string = '/' + this.translationConfig.getTranslation(myGamesTrx);
  readonly promoCodeUrl: string = '/' + this.translationConfig.getTranslation(clientAreaTrx) + '/' + this.translationConfig.getTranslation(redeemPromocodeTrx)
  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.initialize();
    }
  }

  protected initialize() {
    this.toggleBackService.showBack();
    this.bestGamesService.getBestPlayed().pipe(takeUntil(this.unsubscribe)).subscribe((resp) => {
      this.bestGames = resp;
    });

    this.avatarService.getAvatar().pipe(takeUntil(this.unsubscribe)).subscribe(data => this.avatar = data);

    this.loginStatusService.getLoginStatus().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
      // console.log(resp)
      let roleList = (resp.fullInfo?.roles as string[]) || [];
      if (roleList)
        roleList = roleList.map(role => role.toLowerCase());
      this.userRole = roleList.some(role => this.loginStatusService.vipRoles.includes(role));
      this.email = resp.username;
      this.verified = resp?.fullInfo?.verification_status;
      this.subscribeToGamification();
      this.subscribeToChargeback();
      this.subscribeToBonusLottery();
      this.userInfo = resp?.fullInfo;
      this.kyc_status = this.userInfo?.kyc_status;
    });


    this.bonusQueueService.getBonusQueue().pipe(take(1)).subscribe(resp => {
      this.bonusQueue = resp||[]
    })
    this.isDesktop = this.deviceDetectService.isDesktop();
  }

  private subscribeToGamification() {
    this.gamificationSubscription = this.gamificationLevelService.getStore().pipe(
      filter(resp => !!resp),
      takeUntil(this.unsubscribe),
    ).subscribe((resp) => {
      this.handleGamificationResponse(resp);
    });

    this.prizeBoxService.getCurrentLevelLottery(true).pipe(
      filter(resp => resp !== null),
      takeUntil(this.unsubscribe)
    ).subscribe((resp) => {
      this.handlePrizeBoxResponse(resp);
    });
  }

  private handleGamificationResponse(resp) {
    if (resp?.turnover) {
      this.gamificationPercentFill = Math.min(100, resp.turnover / resp.levelEndsTurnover * 100);
    }
    this.gamificationLevel = resp?.levelNumber;
    this.getPlayerList(this.gamificationLevel);
    this.showGamification = true;
  }

  private handlePrizeBoxResponse(resp) {
    this.isPrizeBoxActive = resp.isActive;
  }

  private getPlayerList(number) {
    const index = Math.max(0, Math.min(Math.floor((number - 1) / 5), LEVEL_NAMES.length - 1));
    this.playerLoyalityNameIndex = LEVEL_NAMES.findIndex(name => name === LEVEL_NAMES[index]);
    if (this.playerCurrentLevelList.length === 0) {
      for (let i = 1; i <= 5; i++) {
        this.playerCurrentLevelList.push(i + (this.playerLoyalityNameIndex * 5));
      }
      const progressStep = this.playerCurrentLevelList.findIndex(index => index === number);
      const totalTurnOver = (progressStep * 100) + this.gamificationPercentFill;
      this.gamificationTotalLevelPercent = Math.min(500, totalTurnOver / 500 * 100);
    }
    if (number <= 25) {
      this.lemonIconNameIndex = Math.ceil(this.gamificationLevel / 5);
      this.lemonNextLevelIconNameIndex = Math.ceil(this.gamificationLevel / 5) + 1;
      this.playerLoyalityName = LEVEL_NAMES[index];
      this.playerNextLoyalityName = LEVEL_NAMES[index + 1];
      this.playerLevelPosition = LEVEL_POSITIONS[index];
      this.playerNextLevelPosition = LEVEL_POSITIONS[index + 1];
    } else {
      this.lemonIconNameIndex = Math.ceil(this.gamificationLevel / 5);
      this.lemonNextLevelIconNameIndex = Math.ceil(this.gamificationLevel / 5);
      this.playerLoyalityName = LEVEL_NAMES[index];
      this.playerNextLoyalityName = LEVEL_NAMES[index];
      this.playerLevelPosition = 'Lvl 26';
      this.playerNextLevelPosition = 'Lvl 30';
    }
  }

  private subscribeToChargeback() {
    this.userChargebackToClaim = null;
    this.chargebackSubscription = this.chargebackService.getChargeback(false, true).pipe(
      take(1),
    )
      .subscribe((resp) => {
        if (!!resp.active) {
          const currentDate = new Date();
          const chargebackDateSecs = Math.floor(((resp.active as UserChargeback).convertedDate.getTime() - currentDate.getTime())) / 1000;
          const chargebackDays2Go = (chargebackDateSecs / 60 / 60 / 24);
          
          // If date/time is already passed, do NOT set chargebackFormatted
          if (chargebackDateSecs > 0) {
            const chargeback = $localize`:@@chargeback-luckera :${Math.floor(chargebackDays2Go)}d:${Math.floor(chargebackDateSecs / 60 / 60) % 24}h:${Math.floor(chargebackDateSecs / 60) % 60}m`;
            this.chargebackFormatted = chargeback;
          }else{
            this.chargebackFormatted = '';
          }

          const targetDate = (resp.active as UserChargeback).convertedDate;

          // Total seconds difference
          const diffSecs = Math.floor((targetDate.getTime() - currentDate.getTime()) / 1000);

          // If negative or zero, use 0
          const secs = Math.max(diffSecs, 0);

          // Convert to hours & minutes only
          const hours = Math.floor(secs / 3600);
          const minutes = Math.floor((secs % 3600) / 60);
          if(hours > 0 || minutes > 0){
            const dailyChargeback = $localize`:@@daily-chargeback-luckera :${hours}h:${minutes}m`;
            this.dailyChargebackFormatted = dailyChargeback;
          }else{
            this.dailyChargebackFormatted = '';
          }
          this.chargebackPercentFill = Math.floor((7 - chargebackDays2Go) / 7. * 100.);
          this.userChargeback = (resp.active as UserChargeback);
        }
        if (!!resp.toClaim) {
          this.userChargebackToClaim = (resp.toClaim as UserChargeback);
        }
      });
  }

  private subscribeToBonusLottery() {
    this.bonusLotteryService.updateBonusLottery().pipe(
      take(1)
    ).subscribe(resp => {
      if (!!resp && resp.isActive)
        this.userBonusLotteryResponse = resp;
    });
  }

  openLotteryWheel() {
    this.router.navigate(['', 'client-area', 'lottery-luckera'], { skipLocationChange: true });
  }

  public claimCashback(): void {
    if (!this.userChargebackToClaim) return;

    this.chargebackService
      .claimChargeback(this.userChargebackToClaim)
      .pipe(
        finalize(() => this.subscribeToChargeback()),
        takeUntil(this.unsubscribe)
      )
      .subscribe({
        error: err => console.error('Claim cashback failed', err)
      });
  }

  openPrizeBox() {
    this.router.navigate(['', 'client-area', this.translationConfig.getTranslation(prizeBoxTrx)]);
  }

  getLemonIconNameIndex(): number {
    return Math.ceil(this.gamificationLevel / 5);
  }

  openErrorDialog(msg?: string, title?: string, callback?: Function): void {
    this.dialogOpened = true;
    const size: DialogConfig = TEST_SUCCESS_DIALOG_CONFIG;
    const dialogRef = this.errorDialog.open(ErrorDialogComponent, {
      ...size,
      backdropClass: 'blur-backdrop',
      panelClass: ["transparent", "dialog-card-wrapper", this.isDesktop ? "desktop": "mobile"],
      data: { msg: msg, title: title }
    });
    if (callback) {
      dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe)).subscribe(
        () => {
          callback();
          this.dialogOpened = false;
        }
      );
    }
  }

  openSuccessDialog(msg?: string, title?: string, callback?: Function, additionalButtonLink?: string, image?: any): void {
    this.dialogOpened = true;
    const size: DialogConfig = TEST_SUCCESS_DIALOG_CONFIG;
    const dialogRef = this.errorDialog.open(SuccessDialogComponent, {
      ...size,
      backdropClass: 'blur-backdrop',
      panelClass: ["transparent", "dialog-card-wrapper", this.isDesktop ? "desktop": "mobile", "success-dialog-card-wrapper"],
      data: { msg: msg, title: title, additionalButtonLink: additionalButtonLink, image: image }
    });
    if (callback) {
      dialogRef.afterClosed().pipe(takeUntil(this.unsubscribe)).subscribe(
        () => {
          callback();
          this.dialogOpened = false;
        }
      );
    }
  }

  completeKyc() {
    if(this.userInfo?.kyc_requested){
      this.kycRequested = true
    }else{
      this.router.navigate([`${this.uploadDocumentsTrx}`]);
    }
  }

  getKycStatus(data) {
    if (data.status == 'success') {
      this.openSuccessDialog(data.msg, 'Success!', () => this.callKycUpdate());
    } else {
      this.openErrorDialog(data.msg, null, () => this.kycRequested = false);
    }
  }

  callKycUpdate() {
    this.userFullInfoService.requestFullInfo(true).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res) => {
        this.userInfo = res;
        this.kycRequested = false;
      },
      error: () => { },
    })
  }
}
